export const getSeverityColorClass = (severity: string | null | undefined) => {
  if (!severity || typeof severity !== "string") {
    return "black";
  }

  severity = severity.toUpperCase();
  switch (severity) {
    case "LOW":
      return "text-green-500";
    case "MEDIUM":
      return "text-orange-500";
    case "HIGH":
      return "text-red-500";
    default:
      return "black";
  }
};
